import { Auth } from 'aws-amplify';

export const setAuthHeader = async config => {
  try {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken().getJwtToken();
    config.headers.Authorization = idToken;
    return config;
  } catch {
    console.log('setAuthHeader error');
  }
};

export const retryAndSetAuth = async ({
  fn,
  error,
  response: firstResponse,
  retries = 2,
}) => {
  const errorResponseStatus = error?.response?.status || error?.status;
  try {
    if (
      retries > 0 &&
      (errorResponseStatus === 401 || errorResponseStatus === 403)
    ) {
      const session = await Auth.currentSession();
      const idToken = session.getIdToken().getJwtToken();

      const config = {
        headers: {
          Authorization: idToken,
        },
      };

      const response = await fn(config);
      return { error, response, fn };
    } else {
      if (errorResponseStatus === 401 || errorResponseStatus === 403) {
        window.location.href = `/login?path=${window.location.pathname}`;
      }
    }

    return { error, response: firstResponse, fn };
  } catch {
    return retryAndSetAuth({
      fn,
      error,
      response: firstResponse,
      retries: retries - 1,
    });
  }
};
